// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5b949060","884":"e97dcbbc"}[chunkId] + ".chunk.js";
};